/**
 * Delayed Third-Party Script Loader
 * Loads marketing/analytics scripts after window load + delay or first user interaction
 * to reduce Total Blocking Time (TBT) and main-thread work during critical path.
 * Tracking remains functional; scripts load within 3s of load or on first interaction.
 */
(function() {
  'use strict';

  var config = window.__DELAYED_SCRIPTS_CONFIG || {};
  var loaded = false;
  var POST_LOAD_DELAY_MS = 3000;
  var MAX_WAIT_MS = 4000;
  var start = Date.now();

  function loadNow() {
    if (loaded) return;
    loaded = true;

    // ContentSquare
    if (config.contentsquareSrc) {
      var cs = document.createElement('script');
      cs.src = config.contentsquareSrc;
      cs.async = true;
      document.body.appendChild(cs);
    }

    // Google Analytics (gtag)
    if (config.gaId) {
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      window.gtag = gtag;

      var gaScript = document.createElement('script');
      gaScript.async = true;
      gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + config.gaId;
      gaScript.onload = function() {
        gtag('js', new Date());
        gtag('config', config.gaId);
      };
      document.body.appendChild(gaScript);
    }

    // Optional: additional script URLs from config.extraScripts (array of { src: string } or string)
    var extra = config.extraScripts;
    if (Array.isArray(extra)) {
      extra.forEach(function(item) {
        var src = typeof item === 'string' ? item : (item && item.src);
        if (!src) return;
        var s = document.createElement('script');
        s.src = src;
        s.async = true;
        document.body.appendChild(s);
      });
    }
  }

  function scheduleLoad() {
    if (loaded) return;
    loadNow();
  }

  function onInteraction() {
    scheduleLoad();
    removeListeners();
  }

  function removeListeners() {
    window.removeEventListener('scroll', onInteraction, { passive: true });
    window.removeEventListener('click', onInteraction, true);
    window.removeEventListener('keydown', onInteraction, true);
    window.removeEventListener('touchstart', onInteraction, { passive: true });
  }

  // After load event, wait POST_LOAD_DELAY_MS then load (or cap at MAX_WAIT_MS)
  function onLoad() {
    var elapsed = Date.now() - start;
    var wait = Math.min(Math.max(0, POST_LOAD_DELAY_MS - elapsed), MAX_WAIT_MS - elapsed);
    if (wait <= 0) {
      scheduleLoad();
      return;
    }
    setTimeout(scheduleLoad, wait);
  }

  // Listen for first user interaction to load sooner when user is active
  window.addEventListener('scroll', onInteraction, { passive: true });
  window.addEventListener('click', onInteraction, true);
  window.addEventListener('keydown', onInteraction, true);
  window.addEventListener('touchstart', onInteraction, { passive: true });

  if (document.readyState === 'complete') {
    onLoad();
  } else {
    window.addEventListener('load', onLoad);
  }

  // Fallback: ensure scripts load by MAX_WAIT_MS even if load event never fires
  setTimeout(function() {
    if (!loaded) scheduleLoad();
  }, MAX_WAIT_MS);
})();
